module.exports = __webpack_public_path__ + "fonts/Gibson-SemiBold.f6c659e3.ttf";